import { ReactNode, useContext } from 'react';
import { useAuth } from '@/hooks/auth.hook';
import { PageURLs } from '@/utils/navigate';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@/redux/hooks';
import { watchProfileLoading } from '@/redux/slices/auth.slice';
import { MenuItems } from '@/components/menus/menu-list';
import { AccessPermissionContext } from '@/hooks/access-permission.hook';

type AuthGuardProps = {
  children: ReactNode;
};
export function AuthGuard({ children }: AuthGuardProps) {
  const { isLoggedIn } = useAuth();
  const loading = useAppSelector(watchProfileLoading);
  const { pathname } = useLocation();
  const permissionContext = useContext(AccessPermissionContext);

  const menuItems = MenuItems();

  if (!isLoggedIn && !loading) {
    return <Navigate to={PageURLs.ofLogin()} replace />;
  }

  if (pathname === '/' && isLoggedIn) {
    if (menuItems.length && permissionContext?.roleIndexes) {
      const menu = menuItems[0] as Menu;
      const redirectRoute = menu.children ? menu.children[0].key : menu.key;
      return <Navigate to={redirectRoute} replace />;
    }
  }

  return <>{children}</>;
}
